import PaymentCollection from './finance/PaymentCollection';

/**
 * Legacy `/dashboard/finance/cloudgm/customers/payments` route.
 * Redirects to the new Payment Collection UI scoped to `cloudgm_customers`.
 */
export default function CustomerPayments() {
  return <PaymentCollection platformOverride="cloudgm_customers" />;
}
